import TextInput from 'components/Input';
import Slider from 'components/Slider';
import { device } from 'styles/breakpoints';
import { ActionButton, SectionTextWrapper } from 'styles/global.styles';
import { theme } from 'styles/theme';

import { Segments } from 'data';
import { ChangeEvent } from 'react';
import styled from 'styled-components';

export interface IWorkplace {
  name: string;
  size: number;
  headcount: number;
}

interface IWorkplaceSection {
  workplace: IWorkplace;
  onClick: () => void;
  selectedSegment: string;
  onChange: (key: keyof IWorkplace, value: string | number) => void;
  validationError?: string;
}

const WorkplaceSection = (props: IWorkplaceSection): JSX.Element => {
  const isCompany = Segments.some((segment) => segment.company === props.selectedSegment);

  const isWorkplace = Segments.some((segment) => segment.worplace === props.selectedSegment);

  return (
    <Wrapper>
      <SectionTextWrapper
        sectionNumber={4}
        heading={isCompany ? 'Vad heter er affärsverksamhet?' : 'Hur stor är er arbetsplats?'}
        description="Ange nedan uppgifter för snabbare och mer precis handläggning."
      />

      {isCompany && (
        <CompanyNameWrapper>
          <TextInput
            name="company_name"
            placeholder="Namn"
            error={props.validationError}
            label={
              props.selectedSegment === 'Detaljhandel'
                ? 'Butiken, kedjans eller varumärkets namn'
                : 'Vad heter ert hotell eller restaurang (varumärke)?'
            }
            value={props.workplace.name}
            onChange={(e: ChangeEvent<HTMLInputElement>) => props.onChange('name', e.target.value)}
          />
        </CompanyNameWrapper>
      )}

      {isWorkplace && (
        <>
          <SliderWrapper
            id="workplace"
            label="Ungefär hur stort är ert kontor?"
            step={50}
            value={props.workplace.size}
            onChange={(value: number) => props.onChange('size', value)}
          />

          <EmployeesSliderWrapper
            id="employees"
            label="Hur många personer jobbar på din arbetsplats?"
            step={10}
            max={300}
            value={props.workplace.headcount}
            onChange={(value: number) => props.onChange('headcount', value)}
          />
        </>
      )}

      <ActionButton
        disabled={(isCompany && !props.workplace.name.trim()) || !props.selectedSegment}
        onClick={props.onClick}
      >
        Fortsätt
      </ActionButton>
    </Wrapper>
  );
};

export default WorkplaceSection;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 2rem;
`;

const CompanyNameWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff9f3;
  border-radius: ${theme.dimensions.components.borderRadius};
  padding: 1rem;

  @media ${device.sm} {
    width: ${theme.dimensions.card.width};
  }
`;

const SliderWrapper = styled(Slider)`
  width: 100%;

  @media ${device.sm} {
    max-width: ${theme.dimensions.card.width};
  }
`;

const EmployeesSliderWrapper = styled(SliderWrapper)`
  margin-top: 1rem;
`;
